<script setup>
import { onMounted, onBeforeUnmount, ref, watch } from 'vue'
import AutoNumeric from 'autonumeric'

const props = defineProps({
  modelValue: [Number, String],
  options: Object
})

const emit = defineEmits(['update:modelValue'])

const inputRef = ref(null)
let anInstance = null

onMounted(() => {
  if (inputRef.value) {
    anInstance = new AutoNumeric(inputRef.value, props.modelValue, props.options || {})
    inputRef.value.addEventListener('autoNumeric:rawValueModified', () => {
      emit('update:modelValue', anInstance.getNumber())
    })
  }
})

watch(() => props.modelValue, (newVal) => {
  if (anInstance && newVal !== anInstance.getNumber()) {
    anInstance.set(newVal)
  }
})

onBeforeUnmount(() => {
  if (anInstance) {
    anInstance.remove()
  }
})
</script>

<template>
  <input ref="inputRef" />
</template>
